export const getIsModalOpen = (state) => !!state.getIn(['app', 'modal', 'activeModal']);
export const activeModalIdSelector = (state) => state.getIn(['app', 'modal', 'activeModal']);
